import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { twitterSchema } from './schema';

const TwitterData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = twitterSchema({ ...props, intl });
  console.log('twitter data', schema);
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default TwitterData;
